module.exports = __webpack_public_path__ + "static/img/米老鼠.317d0ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/模型库/米老鼠.png
// module id = sXpR
// module chunks = 1